var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({ display: 'inline-block', maxWidth: '100%' })},[_c('span',_vm._b({class:_vm.$computedClass(_vm.truncate),style:({ display: 'inline-block', maxWidth: '100%' })},'span',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }